import { Operations } from '@grandvisionhq/carts-v2';
import { gql } from '@grandvisionhq/graphql';

const checkoutMutationResult = gql`
  fragment CheckoutMutationResultFragment on CheckoutMutationResponse {
    cart {
      ...CartDetailsFragment
    }
    code
    success
    message
    checkoutState
    __typename
  }
  ${Operations.Fragments.cartDetails}
`;

export { checkoutMutationResult };
//# sourceMappingURL=checkout-mutation-result.js.map
